import type { EventCreateRequestType } from '@cocoonspace/sdk-js/types/eventCreateRequestType'
import { validateBooking } from '@cocoonspace/sdk-js/domains/bookings/bookings'
import { useMutation } from '@tanstack/react-query'

import { bookingFindOrCreate } from './use-booking-find-or-create.hook'

interface BookingVisitMutationArgs {
	space: string
	paymentMethod: string
	day: string
	start: string
	end: string
	type?: EventCreateRequestType
}

export const useBookingVisitMutation = () =>
	useMutation({
		mutationFn: async (data: BookingVisitMutationArgs) => {
			const event = await bookingFindOrCreate({
				day: data.day,
				end: data.end,
				space: data.space,
				start: data.start,
				type: 'visit',
			})

			const validate = await validateBooking(event.booking_id!, {
				payment: [],
				payment_method: data.paymentMethod,
			})

			return {
				event,
				validate,
			}
		},
	})
